import { Injectable } from '@angular/core';
import * as DeviceUUID from 'device-uuid';

import { generateGuid } from '@shared/utils';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceInfoService {
  constructor(private localStorageService: LocalStorageService) {}

  getDeviceUuid() {
    let deviceId = this.localStorageService.load(LocalStorageService.DEVICE_UUID);
    if (!deviceId) {
      deviceId = generateGuid();
      this.localStorageService.store(LocalStorageService.DEVICE_UUID, deviceId);
    }

    return deviceId;
  }

  getDeviceDescription() {
    const deviceInfo = new DeviceUUID.DeviceUUID();
    const result = JSON.stringify(deviceInfo.parse());
    return result;
  }
}
